import React, { useEffect, useRef } from "react";

export default function MapView({ items, height = 480 }) {
  const ref = useRef(null);
  const mapRef = useRef(null);

  useEffect(() => {
    // Lazy-load leaflet from CDN to avoid SSR/CSS issues
    const cssId = "leaflet-css";
    if (!document.getElementById(cssId)) {
      const link = document.createElement("link");
      link.id = cssId;
      link.rel = "stylesheet";
      link.href = "https://unpkg.com/leaflet@1.9.4/dist/leaflet.css";
      document.head.appendChild(link);
    }
    let cancelled = false;
    import("leaflet").then((L) => {
      if (cancelled || !ref.current) return;
      if (mapRef.current) { mapRef.current.remove(); mapRef.current = null; }
      const center = items[0] && items[0].lat ? [items[0].lat, items[0].lng] : [28.0, 2.5];
      const map = L.map(ref.current, { scrollWheelZoom: false }).setView(center, items[0] ? 11 : 5);
      L.tileLayer("https://{s}.tile.openstreetmap.org/{z}/{x}/{y}.png", {
        attribution: "© OpenStreetMap",
      }).addTo(map);

      const icon = L.divIcon({
        className: "naydar-pin",
        html: `<div style="background:#1B8F5A;color:#fff;font-size:11px;font-weight:700;padding:6px 10px;border-radius:999px;box-shadow:0 4px 12px rgba(0,0,0,.2);white-space:nowrap;">●</div>`,
        iconSize: [28, 28], iconAnchor: [14, 28],
      });

      items.filter((i) => i.lat && i.lng).forEach((p) => {
        const m = L.marker([p.lat, p.lng], { icon }).addTo(map);
        m.bindPopup(`<a href="/property/${p.id}" style="text-decoration:none;color:#111">
          <div style="width:200px"><img src="${p.images?.[0] || ""}" style="width:100%;height:110px;object-fit:cover;border-radius:8px" /><div style="font-weight:700;margin-top:6px">${p.title}</div><div style="color:#1B8F5A;font-weight:700;margin-top:2px">${p.price_on_request ? "Prix sur demande" : new Intl.NumberFormat("fr-FR").format(p.price_da) + " DA"}</div></div></a>`);
      });
      mapRef.current = map;
    });
    return () => { cancelled = true; if (mapRef.current) { mapRef.current.remove(); mapRef.current = null; } };
  }, [items]);

  return <div ref={ref} style={{ height: `${height}px`, width: "100%", borderRadius: 16, overflow: "hidden" }} data-testid="map-view" />;
}
